<script>
import { mapGetters } from 'vuex'

import { apiSecond } from '@/boot/axios'

export default {
	name: 'CatchPermissions',
	props: {
		userTag: {
			type: String,
		},
		isSalesman: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			data: null,
		}
	},
	computed: {
		...mapGetters('dashboard', ['getSelectedFishingYear']),
	},
	watch: {
		// Перезагружаем блок при смене периода в шапке дашборда
		getSelectedFishingYear() {
			this.getData()
		},
	},
	mounted() {
		this.getData()
	},
	methods: {
		async getData() {
			try {
				// Без дат бэк берёт период из config/period.php — передаём выбранный пользователем
				const params = {
					date_from: this.getSelectedFishingYear?.start,
					date_to: this.getSelectedFishingYear?.finish,
				}
				const response = await apiSecond.get(`v1/dashboard/${this.userTag}/percentage-trade-fish`, {
					params,
				})

				if (response?.data?.data) {
					this.data = response?.data?.data
				} else {
					// Set empty array to show empty state
					this.data = []
				}
			} catch (error) {
				console.log(error)
				// Set empty array on error too
				this.data = []
			}
		},
	},
}
</script>

<template>
	<div
		class="bg-white/90 p-[30px] shadow-main rounded-b-[10px] backdrop-blur-[10px] overflow-y-auto max-h-[470px] scrollbar-blue"
	>
		<template>
			<div class="w-full flex justify-between items-center gap-[10px] mb-[24.18px]">
				<div class="font-main font-semibold text-[18px] text-third uppercase">
					{{
						isSalesman ? $t('titles.catch_permissions_salesman') : $t('titles.catch_permissions')
					}}
				</div>
			</div>
			<div>
				<!-- Show data when available -->
				<div v-if="data && data.length > 0">
					<div v-for="(fish, fishInd) in data" :key="fish.fish_id">
						<div
							class="flex gap-[10px] mb-[10px] font-main font-medium text-[14px] text-second leading-[1.43]"
						>
							<span>{{ fishInd + 1 }}</span>
							<span>{{ fish.fishName }}</span>
						</div>
						<div
							:class="{ 'mb-[30px]': fishInd < data.length - 1 }"
							class="grid grid-cols-1 md:grid-cols-4 gap-[22px]"
						>
							<div
								class="flex items-center justify-between gap-[10px] pb-[11px] border-b-[2px] border-b-solid border-b-[#FFA800]"
							>
								<span class="font-main font-medium text-[12px] text-second leading--[1.66]">{{
									$t('labels.quato')
								}}</span>
								<span class="font-main font-bold text-[16px] text-second leading--[1.25]"
									>{{ fish.quota_total_value | formatNumber }} кг</span
								>
							</div>
							<div
								class="flex items-center justify-between gap-[10px] pb-[11px] border-b-[2px] border-b-solid border-b-[#FFA800]"
							>
								<span class="font-main font-medium text-[12px] text-second leading--[1.66]">{{
									$t('labels.permissions')
								}}</span>
								<span class="font-main font-bold text-[16px] text-second leading--[1.25]"
									>{{ fish.permission_total_value | formatNumber }} кг</span
								>
							</div>
							<div
								class="flex items-center justify-between gap-[10px] pb-[11px] border-b-[2px] border-b-solid border-b-[#00E096]"
							>
								<span class="font-main font-medium text-[12px] text-second leading--[1.66]">{{
									$t('labels.quota_all')
								}}</span>
								<span class="font-main font-bold text-[16px] text-second leading--[1.25]"
									>{{ fish.trade_total_value | formatNumber }} кг</span
								>
							</div>
							<div
								class="flex items-center justify-between gap-[10px] pb-[11px] border-b-[2px] border-b-solid border-b-[#0095FF]"
							>
								<span class="font-main font-medium text-[12px] text-second leading--[1.66]">{{
									$t('labels.remainder_permissions') + ' | %'
								}}</span>
								<span class="font-main font-bold text-[16px] text-second leading--[1.25]">{{
									(100 - fish.percentage_permission_trade) | formatNumber
								}}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Show empty state when no data -->
				<div v-else class="flex flex-col items-center justify-center h-[300px] text-center">
					<img src="@/assets/svgs/permissions.svg" alt="" class="block w-16 h-16 mb-4 opacity-50" />
					<div class="font-main font-medium text-[16px] text-fourth leading-[1.5] mb-2">
						{{ $t('messages.no_permissions_data') || 'Нет данных о разрешениях' }}
					</div>
					<div class="font-main font-normal text-[14px] text-second leading-[1.5]">
						{{
							$t('messages.select_fishing_period') ||
							'Выберите период рыболовства для отображения данных'
						}}
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
